import React from 'react';
import { useMediaQuery } from 'react-responsive';
import { ThemeProvider } from '@material-ui/styles';
import { CssBaseline } from '@material-ui/core';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import Content from './components/layout/Content';
import Footer from './components/layout/Footer';
import Header from './components/layout/Header';
import MainTheme from './muiTheme';
import store from './redux/store';
import ScrollToTop from './scrollToTop';

function App() {
  const isMobile = useMediaQuery({ maxWidth: 1200 });

  return (
    <Provider store={store}>
      <ThemeProvider theme={MainTheme}>
        <Router>
          <CssBaseline />
          <ScrollToTop />
          <Header mobile={isMobile} />
          <Content mobile={isMobile} />
          <Footer mobile={isMobile} />
        </Router>
      </ThemeProvider>
    </Provider>
  );
}

export default App;
